import { render } from "./AccessTable.vue?vue&type=template&id=5ec5952a"
import script from "./AccessTable.vue?vue&type=script&lang=js"
export * from "./AccessTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__